import { escapeHtml } from "@emkit/builder-core";
export const PROGRESS_DEFAULTS = {
    value: 65,
    max: 100,
    label: "Progress",
    showValue: true,
    style: "rounded",
    fillColor: "#111827",
    trackColor: "#e5e7eb",
    height: 10,
};
export const progressWidget = {
    type: "progress",
    defaultProps: PROGRESS_DEFAULTS,
    renderHtml(props) {
        const value = Math.max(0, props.value);
        const max = Math.max(1, props.max ?? 100);
        const pct = Math.min(100, (value / max) * 100);
        const height = props.height ?? 10;
        const fill = props.fillColor ?? "#111827";
        const track = props.trackColor ?? "#e5e7eb";
        const style = props.style ?? "rounded";
        const radius = style === "linear" ? 0 : Math.round(height / 2);
        const stripePattern = style === "striped"
            ? `background-image:linear-gradient(45deg,rgba(255,255,255,0.25) 25%,transparent 25%,transparent 50%,rgba(255,255,255,0.25) 50%,rgba(255,255,255,0.25) 75%,transparent 75%,transparent);background-size:1rem 1rem;`
            : "";
        const header = props.label || props.showValue
            ? `<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;font-size:14px;font-family:inherit">${props.label ? `<span style="font-weight:500">${escapeHtml(props.label)}</span>` : "<span></span>"}${props.showValue ? `<span style="opacity:0.7;font-variant-numeric:tabular-nums">${Math.round(pct)}%</span>` : ""}</div>`
            : "";
        return `<div class="emk-progress" style="font-family:inherit">${header}<div role="progressbar" aria-valuenow="${value}" aria-valuemin="0" aria-valuemax="${max}" style="height:${height}px;background:${track};border-radius:${radius}px;overflow:hidden"><div style="width:${pct}%;height:100%;background:${fill};${stripePattern}border-radius:${radius}px;transition:width 0.3s"></div></div></div>`;
    },
};
//# sourceMappingURL=progress.js.map